// hooks/useFormValidation.js
import { useState, useCallback } from "react";
import { validate } from "utils/helpers/validationHelper";

export function useFormValidation(rules) {
    const [errors, setErrors] = useState({});

    const validateForm = useCallback(
        (form) => {
            const newErrors = validate(form, rules);
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        },
        [rules]
    );

    const clearFieldError = useCallback((field) => {
        setErrors((prev) => {
            if (!prev[field]) return prev;
            const next = { ...prev };
            delete next[field];
            return next;
        });
    }, []);

    return { errors, validateForm, clearFieldError, setErrors };
}
